<template>
  <router-view />
</template>

<script>
import storeMixin, {
  unRegisterMixin,
} from '@quisit/mipe-utils/mixins/storeGenerator';
const STORE_MODULE_NAME = 'ServiceSatisfactionQuestionnaireModule';

export default {
  name: 'WrapperServiceSatisfactionQuestionnaire',
  mixins: [unRegisterMixin, storeMixin],
  data: () => ({
    moduleName: STORE_MODULE_NAME,
  }),
};
</script>
